<app-reservation-table [dataSource]="dataSource" [displayedColumns]="displayedColumns" [totalCount]="totalCount"
  [pageSize]="pageSize" [pageIndex]="pageIndex" [isLoading]="isLoading" [errorClassFn]="errorClassFn"
  [canCheckInFn]="canCheckInFn" [canCheckOutFn]="canCheckOutFn" [canCancelFn]="canCancelFn" [canEditFn]="canEditFn"
  [canRegisterPaymentFn]="canRegisterPaymentFn" (pageChange)="pageChange.emit($event)"
  (actionClick)="actionClick.emit($event)">
</app-reservation-table>

<div class="actions">
  <button mat-raised-button color="primary" (click)="printInProgressList()">
    <mat-icon class="pdf-icon">picture_as_pdf</mat-icon> Generar pdf
  </button>
</div>

<div style="display: none;">
  <div id="printablecontent" class="report-header">
    <img src="assets/logo.png" alt="Logo" class="logo">
    <div class="header-info">
      <h1>Alfa Hostal</h1>
      <p>{{today.toLocaleDateString()}}</p>
    </div>
    <h2 class="title">Reporte de huéspedes</h2>
    <div>
      <table>
        <thead>
          <tr>
            <th>Hab.</th>
            <th>huésped</th>
            <th>Documento</th>
            <th>Dirección de Origen</th>
            <th>País de Origen</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of details">
            <td>{{item.roomNumber}}</td>
            <td>{{item.lastName}} {{item.firstName}}</td>
            <td>{{item.documentType | documentTypeLabel}} - {{item.documentNumber}}</td>
            <td>{{item.originAddress}}</td>
            <td>{{item.countryOfOrigin}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>